import { render, staticRenderFns } from "./ListProducts.vue?vue&type=template&id=2067fd73&scoped=true"
import script from "./ListProducts.vue?vue&type=script&lang=js"
export * from "./ListProducts.vue?vue&type=script&lang=js"
import style0 from "./ListProducts.vue?vue&type=style&index=0&id=2067fd73&prod&lang=scss"
import style1 from "./ListProducts.vue?vue&type=style&index=1&id=2067fd73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2067fd73",
  null
  
)

export default component.exports